import React from 'react';
import { OptionInfo, TargetField } from '#/common/components/ColumnMapper';
import MandatoryFieldsStepBase from '../base/MandatoryFieldsStepBase';

// Define the mandatory fields
const mandatoryFields = [
  {
    key: 'third_party_id',
    label: 'Capital Need ID',
    required: true,
    unique: true,
    noUnknownOption: true,
  },
  {
    key: 'title',
    label: 'Title',
    required: true,
    noUnknownOption: true,
  },
  {
    key: 'asset_identifier',
    label: 'Asset',
    isDropdown: true,
    required: true,
    noUnknownOption: true,
    values: [
      { key: 'asset_tag', label: 'Asset Tag' },
      { key: 'serial_number', label: 'Serial Number' },
    ],
  },
] as TargetField[];

export interface MapCapitalNeedMandatoryFieldsStepProps {
  csvColumns: OptionInfo[];
  mapping: Record<string, string>;
  setMapping: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  targetDropdownSelections: Record<string, string>;
  setTargetDropdownSelections: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

const MapCapitalNeedMandatoryFieldsStep: React.FC<MapCapitalNeedMandatoryFieldsStepProps> = ({
  csvColumns,
  mapping,
  setMapping,
  targetDropdownSelections,
  setTargetDropdownSelections,
  setIsValid,
}) => {
  return (
    <MandatoryFieldsStepBase
      csvColumns={csvColumns}
      mapping={mapping}
      setMapping={setMapping}
      targetDropdownSelections={targetDropdownSelections}
      setTargetDropdownSelections={setTargetDropdownSelections}
      setIsValid={setIsValid}
      mandatoryFields={mandatoryFields}
      uniqueFieldsMessage="This will be your unique identifier field. The value should be unique for each capital need."
      uniqueFieldsMessageSeeMore="The unique identifier is used to define the capital need unequivocally and if another record with the same Capital Need ID is uploaded, its information might update or supersede the existing record."
      warningContent={
        <>
          The Asset value must match an existing Asset by Asset Tag or Serial Number, otherwise the
          row will fail to import.
        </>
      }
    />
  );
};

export default React.memo(MapCapitalNeedMandatoryFieldsStep);
